import Layout from "@/layout";

export default {
  path: "/intercept",
  component: Layout,
  name: 'interceptIndex',
  children: [
    {
      path: "potential-loads",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/load-board/potential-loads',},
    },
    {
      path: "loadAlert",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/load-board/load-alert',},
    },
    {
      path: "connect",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/load-board/connect',},
    },
    {
      path: "density",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/load-board/density',},
    },
    {
      path: "postTruck",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/load-board/post-truck',},
    },

    {
      path: "dashboard",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/dashboard',},
    },
    {
      path: "dispatchLoads",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/dispatch/loads',},
    },
    {
      path: "schedule",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/dispatch/schedule',},
    },
    {
      path: "dispatchLoadsLayout",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/dispatch',},
    },

    {
      path: "drivers",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/driver/index',},
    },

    {
      path: "contacts",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/contacts/index',},
    },

    {
      path: "document",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/document/index',},
    },

    {
      path: "Accounting",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/accounting',},
    },
    {
      path: "driverSettlement",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/accounting/driverSettlement',},
    },
    {
      path: "Invoice",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/accounting/accountingInvoice',},
    },
    {
      path: "expense",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/accounting/expense',},
    },
    {
      path: "quickbooks",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/accounting/quickbooks',},
    },
    {
      path: "IFTA",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/accounting/ifta/mileage',},
    },

    {
      path: "Assets",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/assets',},
    },
    {
      path: "Trucks",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/assets/trucks',},
    },
    {
      path: "Trailers",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/assets/trailers',},
    },
    {
      path: "message",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/message/index',},
    },
    {
      path: "bulletin",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept", activeMenu: '/bulletin/index',},
    },
    {
      path: "permissionSettings",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept",},
    },
    {
      path: "Maintenance",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept",},
    },
    {
      path: "transactions",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept",},
    },    
    {
      path: "fuel-order",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept",},
    },    
    {
      path: "find-deals",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept",},
    },    
    {
      path: "*",
      component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
      hidden: true,
      meta: {title: "intercept",},
    },
    
  ]
}